"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./PopoverAuto.module.css"));
var classnames_1 = __importDefault(require("classnames"));
var Popover = function (_a) {
    var content = _a.content, children = _a.children;
    var _b = (0, react_1.useState)(true), showPopover = _b[0], setShowPopover = _b[1];
    var buttonRef = (0, react_1.useRef)(null);
    var popoverContentRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            if (buttonRef.current &&
                !buttonRef.current.contains(event.target) &&
                popoverContentRef.current &&
                !popoverContentRef.current.contains(event.target)) {
                setShowPopover(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [buttonRef, popoverContentRef]);
    var handleButtonClick = function () {
        setShowPopover(!showPopover);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: styles.popover },
            react_1.default.createElement("span", { ref: buttonRef, onClick: handleButtonClick }, children),
            showPopover && (react_1.default.createElement("div", { ref: popoverContentRef, className: (0, classnames_1.default)(styles.popoverContent) },
                react_1.default.createElement("div", { className: styles.popoverInnerContent }, content))))));
};
exports.Popover = Popover;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9wb3Zlci5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvUG9wb3Zlci9Qb3BvdmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUF3RDtBQUN4RCwrREFBa0Q7QUFDbEQsMERBQTJCO0FBRXBCLElBQU0sT0FBTyxHQUFHLFVBQUMsRUFBbUI7UUFBbEIsT0FBTyxhQUFBLEVBQUUsUUFBUSxjQUFBO0lBQ2hDLElBQUEsS0FBZ0MsSUFBQSxnQkFBUSxFQUFDLElBQUksQ0FBQyxFQUE3QyxXQUFXLFFBQUEsRUFBRSxjQUFjLFFBQWtCLENBQUE7SUFDcEQsSUFBTSxTQUFTLEdBQUcsSUFBQSxjQUFNLEVBQUMsSUFBSSxDQUFDLENBQUE7SUFDOUIsSUFBTSxpQkFBaUIsR0FBRyxJQUFBLGNBQU0sRUFBQyxJQUFJLENBQUMsQ0FBQTtJQUV0QyxJQUFBLGlCQUFTLEVBQUM7UUFDTixJQUFNLGtCQUFrQixHQUFHLFVBQUMsS0FBSztZQUM3QixJQUNJLFNBQVMsQ0FBQyxPQUFPO2dCQUNqQixDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUM7Z0JBQ3pDLGlCQUFpQixDQUFDLE9BQU87Z0JBQ3pCLENBQUMsaUJBQWlCLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEVBQ25EO2dCQUNFLGNBQWMsQ0FBQyxLQUFLLENBQUMsQ0FBQTthQUN4QjtRQUNMLENBQUMsQ0FBQTtRQUVELFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxXQUFXLEVBQUUsa0JBQWtCLENBQUMsQ0FBQTtRQUUxRCxPQUFPO1lBQ0gsUUFBUSxDQUFDLG1CQUFtQixDQUFDLFdBQVcsRUFBRSxrQkFBa0IsQ0FBQyxDQUFBO1FBQ2pFLENBQUMsQ0FBQTtJQUNMLENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRSxpQkFBaUIsQ0FBQyxDQUFDLENBQUE7SUFFbEMsSUFBTSxpQkFBaUIsR0FBRztRQUN0QixjQUFjLENBQUMsQ0FBQyxXQUFXLENBQUMsQ0FBQTtJQUNoQyxDQUFDLENBQUE7SUFFRCxPQUFPLENBQ0gsOEJBQUMsZUFBSyxDQUFDLFFBQVE7UUFDWCx3Q0FBTSxTQUFTLEVBQUUsTUFBTSxDQUFDLE9BQU87WUFDM0Isd0NBQU0sR0FBRyxFQUFFLFNBQVMsRUFBRSxPQUFPLEVBQUUsaUJBQWlCLElBQzNDLFFBQVEsQ0FDTjtZQUNOLFdBQVcsSUFBSSxDQUNaLHVDQUFLLEdBQUcsRUFBRSxpQkFBaUIsRUFBRSxTQUFTLEVBQUUsSUFBQSxvQkFBRSxFQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUM7Z0JBQzdELHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsbUJBQW1CLElBQUcsT0FBTyxDQUFPLENBQ3pELENBQ1QsQ0FDRSxDQUNNLENBQ3BCLENBQUE7QUFDTCxDQUFDLENBQUE7QUExQ1ksUUFBQSxPQUFPLFdBMENuQiJ9